import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  showSidebar: {
    description: 'toggleSidebarButton.showSidebar',
    defaultMessage: 'Show Sidebar',
    id: '6DDCw/',
  },
});
